// Store config
import { configureStore, combineReducers } from "@reduxjs/toolkit";

// Custom reducers
import userStateReducer from "../features/userState/userStateSlice";
import applicationStateReducer from "../features/applicationState/applicationStateSlice";
import patientStateReducer from "../features/patientState/patientStateSlice";

// Redux persist
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Combining all reducers into one
const rootReducer = combineReducers({
  userState: userStateReducer,
  applicationState: applicationStateReducer,
  patientState: patientStateReducer,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["userState", "patientState"],
};

// Creating persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Creating store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persitor = persistStore(store);

export default store;
